import OpenModal from 'app/components/VideoModal/OpenModal';
import React from 'react';
import { getAccessServiceDescription } from '../../../../domain/AccessServiceTypes';
import CONTENTO_ACCESSIBILITIES from '../../../../domain/ContentoAccessibilities';
import { SVG_ICONS } from '../../../../ui-components/SvgIcon/SvgIcon';
import {
    StyledTopBarVariantIcon,
    StyledTopBarVariantLink,
    StyledTopBarVariantNoWrap,
} from './TopBarVariant.styles';

export const getIcon = (accessibility) => {
    if (accessibility === CONTENTO_ACCESSIBILITIES.SIGN_INTERPRETED) {
        return SVG_ICONS.SIGN_LANGUAGE;
    }

    if (accessibility === CONTENTO_ACCESSIBILITIES.AUDIO_DESCRIBED) {
        return SVG_ICONS.SIGHT;
    }

    return null;
};

const TopBarVariant = ({ index, variant, onClick }) => {
    const isFirstVariant = index === 0;
    const prepend = isFirstVariant
        ? `Finns även ${variant.accessibility !== CONTENTO_ACCESSIBILITIES.DEFAULT ? 'som ' : ''}`
        : ` och ${variant.accessibility !== CONTENTO_ACCESSIBILITIES.DEFAULT ? 'som ' : ''}`;

    return (
        <>
            {prepend}
            <StyledTopBarVariantNoWrap>
                {variant.accessibility !== CONTENTO_ACCESSIBILITIES.DEFAULT && (
                    <StyledTopBarVariantIcon icon={getIcon(variant.accessibility)} width={20} />
                )}
                <OpenModal videoId={variant.svtId} videoUrl={variant.urls.svtplay}>
                    {(handleOpenModal) => (
                        <StyledTopBarVariantLink
                            onClick={() => {
                                handleOpenModal();
                                onClick(variant.accessibility);
                            }}
                            data-rt="top-bar-a11y-link"
                            isFirstVariant={isFirstVariant}
                        >
                            {getAccessServiceDescription(variant.accessibility)}
                        </StyledTopBarVariantLink>
                    )}
                </OpenModal>
            </StyledTopBarVariantNoWrap>
        </>
    );
};

export default TopBarVariant;
